export default "__VITE_ASSET__Bo91UsFs__"